import script from "./Burger.vue?vue&type=script&setup=true&lang=js"
export * from "./Burger.vue?vue&type=script&setup=true&lang=js"

import "./Burger.vue?vue&type=style&index=0&id=c5368c3c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5368c3c"]])

export default __exports__